import type { Niveau4Lexicon, UserProfile } from '../types';

export function effectiveNiveau4Lexicon(user: UserProfile): Niveau4Lexicon {
  return user.preferences?.niveau4Lexicon === 'en' ? 'en' : 'da';
}

export function niveau4LexiconLabel(lexicon: Niveau4Lexicon): string {
  return lexicon === 'en' ? 'Engelsk' : 'Dansk';
}
